import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authorize_vnc_channel, get_package_versions, release_vnc_channel, update_destination, vnc_check_for_authorized_slot } from '../../../utils/services';
import './Device_header.css';
import { set } from 'date-fns';
import remoteSupportButton from '../../../assets/remote_support_t8.jpg';

const Device_header = ({name,  packages, permission, 
                        token, onRefresh, warranty_covered,
                        model,
                        serial_number,
                        manufactured_date,
                        item_status,
                        licenses,
                        onEditLicense,
                        onDeleteLicense,
                        onAddLicense,
                        formatDate,
                        showRemoteSupport,
                        subscriptors_manager,
                        t8SubscriptionSerial,
                        t8SubscriptionButtonLabel}) => {


  const [editIndex, setEditIndex] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [slotData, setslotData] = useState("");
  const [helpdesk_port, setHelpdesk_port] = useState(null);
  const [adminOptionsExpanded, setAdminOptionsExpanded] = useState(false);

  
   const vncsteps = {
    1: {
      stepText: 'Obtener un canal autorizado.',
      actionText: 'Solicitar',
      nextStep: 2,
    },
    2: {
      stepText: 'Pide al usuario que active el Soporte remoto en su TOMi8 usando el botón en la configuración.',
      actionText: 'Liberar canal',
      nextStep: 3,
    },
    3: {
      stepText: 'El usuario está a la espera',
      actionText: 'Liberar canal',
      nextStep: 3, // El último paso se mantiene para evitar que el botón avance más allá.
    },
  };

  const { stepText, actionText } = vncsteps[currentStep];
 const [isLoading, setIsLoading] = useState(false); // Nuevo estado para controlar el círculo de carga

  const [versionsdropdownOptions, setVersionsDropdownOptions] = useState([]); 
  
  const navigate = useNavigate();
  const intervalRef = useRef(null);
    


  const handleDoubleClick = (index, destination) => {

      if (parseInt(permission)<=2){ // pueden actualizar paquetes 1 y 2, TENER EN CUENTA QUE USUARIOS EXTERNOS DEBERIAN TENER 3
        setEditIndex(index);
        loadPackgesversions(packages[index].name, packages[index].current);

      }
  };

    const handleBlurOrEnter = (packageId, destination) => {
    handleUpdateDestination(packageId,destination);
  };


  useEffect(() => {
    simulatedPollingFunction();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [serial_number]);

  const clearPolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const resetVncFlow = () => {
    clearPolling();
    setCurrentStep(1);
    setIsLoading(false);
    setslotData("");
    setHelpdesk_port(null);
  };


    async function authorizeChannel(serialnum) {
        const memberUpdate = await authorize_vnc_channel(token, serialnum);
        if (memberUpdate==="INVALID"){
          navigate("/");
        }else if (!memberUpdate?.ok){
          alert(memberUpdate?.message || "No se pudo autorizar un canal remoto.");
          resetVncFlow();
        }else{
          setCurrentStep(2);
          setIsLoading(true); // Activa el círculo de carga
          const reservedSlot = memberUpdate?.data?.slot;
          if (reservedSlot?.client_port) {
            setHelpdesk_port(reservedSlot.client_port);
          }
          // Ejecuta la función inmediatamente al entrar al paso 2
          simulatedPollingFunction();
          clearPolling();
          intervalRef.current = setInterval(simulatedPollingFunction, 5000);
                  
       }
      }

  const simulatedPollingFunction = () => {
   
     async function fetchCheck_slot_status(serialnum) {
        const slot_status = await vnc_check_for_authorized_slot(token, serialnum);
        if (slot_status==null){
           resetVncFlow();
         } else if (slot_status === "INVALID"){
         
          navigate("/");
        } else if (!slot_status?.ok) {
                  if (slot_status?.code === "SLOT_NOT_FOUND") {
                    resetVncFlow();
                  } else {
                    console.warn("Estado de slot inesperado:", slot_status);
                    setIsLoading(false);
                  }
        }else{
                  const activeSlot = slot_status?.data?.slot;
                  if (!activeSlot) {
                    resetVncFlow();
                    return;
                  }
                  if (String(activeSlot.server_status)==="1"){
                    setIsLoading(false);
                    clearPolling();
                    setCurrentStep(3);
                  } else {
                    if (currentStep!==2){
                      setCurrentStep(2);
                      clearPolling();
                      intervalRef.current = setInterval(simulatedPollingFunction, 5000);
                      setIsLoading(true);
                    }
                    setslotData(
                        "Puerto Reservado: " + activeSlot.client_port +  
                        "<br />Time: " + time2connect(activeSlot.reserved_until) + " segundos max"
                      );
                      setHelpdesk_port(activeSlot.client_port);
                      
                  }
        }
      }
      fetchCheck_slot_status(serial_number);

   
   
    // Aquí puedes integrar tu lógica real de "polling"
    // Por ejemplo, verificar si el usuario ya se conectó a través de una API.
    // Si la condición se cumple, puedes cambiar el currentStep.
    // Ejemplo:
    // if (alguienSeConecto) {
    //   setCurrentStep(3);
    // }
  };

  const time2connect = (reserved_until_string) => {

    // 1. Parsear la cadena a un objeto de fecha
    const reserved_until_date = new Date(reserved_until_string.replace(' ', 'T'));

    // 2. Obtener la hora actual en milisegundos
    const now_in_ms = new Date().getTime();

    // 3. Obtener la fecha de reserva en milisegundos
    const reserved_until_in_ms = reserved_until_date.getTime();

    
    // Calcular la diferencia en milisegundos
    const diff_in_ms = reserved_until_in_ms - now_in_ms;

    // Convertir la diferencia a segundos y redondear hacia abajo para obtener un número entero
    const seconds_left = Math.floor(diff_in_ms / 1000);

    return Math.max(0, seconds_left);
  }
  const handleUpdateDestination = (packageId,newDestination) => {
  
      async function fetchUpdatemember() {
        const memberUpdate = await update_destination(token, packageId, newDestination);
        if (memberUpdate==="INVALID"){
          navigate("/");
        }else{
          setEditIndex(null);
          onRefresh();
                  
       }
      }
      fetchUpdatemember(packageId);
};

const connectUser = () => {
  if (!helpdesk_port) {
    alert("No hay un puerto VNC disponible todavía.");
    return;
  }

  const endpoint = `team.tomi.la::${helpdesk_port}`;

  // Formato de archivo de configuracion soportado por RealVNC Viewer.
  const vncConfig = [
    // RealVNC interpreta mejor puerto explicito en Host con doble ":".
    `Host=${endpoint}`,
    `Desktop=TOMi8 ${serial_number}`,
    "ConnMethod=tcp",
  ].join("\n");

  const blob = new Blob([vncConfig], { type: "application/octet-stream" });
  const fileUrl = URL.createObjectURL(blob);
  const filename = `tomi8_${serial_number || "remote"}_${helpdesk_port}.vnc`;

  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(fileUrl);
}


 /*
    Obtiene las versiones disponibles de cada paquete
    */
  
    const loadPackgesversions = (packageName, current_version) => {
  
       async function fetchPackageVersion(packageName, current_version) {
            const packageslist = await get_package_versions(token, packageName, current_version);
            if (packageslist==="INVALID"){
              navigate("/");
            }else if (packageslist.length ==0){
              const packageNamesversions = [];
              packageNamesversions.unshift({
                version: 0,
                version_detailed: "Updated"
              });
              setVersionsDropdownOptions(packageNamesversions);
            }else{
              const packageNamesversions = packageslist.map((element, index) => {
                return { version: element.version, version_detailed: element.version_detailed, index: index };
              });
    
              packageNamesversions.unshift({
                version: 0,
                version_detailed: "Nueva"
              });
              setVersionsDropdownOptions(packageNamesversions);
              
           }
          }
      
          fetchPackageVersion(packageName, current_version);
    }


    const handleCopy = async () => {
    try {
      
      await navigator.clipboard.writeText("team.tomi.la::" + helpdesk_port);
      alert('¡Dirección copiada al portapapeles!');
    } catch (err) {
      console.error('Error al copiar: ', err);
      alert('Error al copiar la dirección. Por favor, cópiala manualmente.');
    }
  };

    const handleNextStep = () => {
      switch (currentStep) {
        case 1:
          // Asigno un canal autorizado para el serial 
          authorizeChannel(serial_number);
          break;
        case 2:
        case 3:
          releaseChannel(serial_number);
          break;
      }
 
  };

  async function releaseChannel(serialnum) {
    const releaseResult = await release_vnc_channel(token, serialnum);
    if (releaseResult === "INVALID") {
      navigate("/");
      return;
    }
    if (!releaseResult?.ok && releaseResult?.code !== "SLOT_NOT_FOUND") {
      alert(releaseResult?.message || "No se pudo liberar el canal remoto.");
      return;
    }

    resetVncFlow();
  }

    return (
    <div className="container-fluid">
      <button
        type="button"
        className="device-admin-toggle"
        onClick={() => setAdminOptionsExpanded((prev) => !prev)}
        aria-expanded={adminOptionsExpanded}
      >
        <i className={`bi bi-chevron-${adminOptionsExpanded ? 'down' : 'right'} me-2`} />
        Opciones administrativas
        <span className="device-admin-toggle-hint">
          Paquetes · Licencias
          {subscriptors_manager && String(subscriptors_manager) !== '0' && t8SubscriptionSerial
            ? ` · ${t8SubscriptionButtonLabel || 'T8'}`
            : ''}
          {parseInt(permission) === 1 ? ' · Soporte remoto' : ''}
        </span>
      </button>

      {adminOptionsExpanded && (
        <div className="row">
          {/* Panel 1: Paquetes */}
          <div className="col-md-5">
            <div
              className="device-header-panel shadow-sm rounded"
              style={{
                background: 'linear-gradient(90deg, #e0f2fe, #f0f9ff)',
                border: '1px solid #dbeafe',
              }}
            >
              <table className="table table-sm table-bordered align-middle text-center bg-white device-packages-table">
                <thead className="table-light">
                  <tr>
                    <th className="text-start" style={{ width: '52%' }} title="Paquete">Paquete</th>
                    <th style={{ width: '24%' }} title="Actualizado">Fecha</th>
                    <th style={{ width: '12%' }} title="Versión actual">Act.</th>
                    <th style={{ width: '12%' }} title="Versión destino">Obj.</th>
                  </tr>
                </thead>
                <tbody>
                  {packages.map((pkg, index) => (
                    <tr key={pkg.id}>
                      <td className="text-start package-name" title={pkg.name}>{pkg.name}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        {pkg.date === "0000-00-00 00:00:00" ? (
                          <span className="text-muted">--</span>
                        ) : (
                          <span className="font-monospace">{pkg.date.slice(0, 10)}</span>
                        )}
                      </td>
                      <td>
                        <span className={`badge ${pkg.current < pkg.destination ? 'bg-warning text-dark' : 'bg-success'}`}>
                          {pkg.current}
                        </span>
                      </td>
                      <td
                        onDoubleClick={() => handleDoubleClick(index, pkg.destination)}
                        onBlur={() => handleBlurOrEnter(pkg.id)}
                      >
                        {editIndex === index ? (
                          <select
                            className="form-select form-select-sm"
                            onChange={(e) => handleBlurOrEnter(pkg.id, e.target.value)}
                          >
                            {versionsdropdownOptions.map((opt, i) => (
                              <option key={i} value={opt.version}>
                                {opt.version_detailed}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <span className="badge bg-info text-dark">{pkg.destination}</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Panel 2: Licencias */}
          <div className="col-md-4">
            <div
              className="device-header-panel shadow-sm rounded"
              style={{
                background: 'linear-gradient(90deg, #e0f2fe, #f0f9ff)',
                border: '1px solid #dbeafe',
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-1">
                <h5 className="mb-0" style={{ fontSize: '0.85rem' }}>Licencias</h5>
                <div className="d-flex gap-1 align-items-center">
                  {subscriptors_manager && String(subscriptors_manager) !== '0' && t8SubscriptionSerial && (
                    <button
                      className="btn btn-sm btn-outline-primary"
                      type="button"
                      title={`Suscripción T8 (${t8SubscriptionSerial})`}
                      onClick={() => {
                        navigate(`/helpdesk/suscripciones-t8?serial=${encodeURIComponent(t8SubscriptionSerial)}`);
                      }}
                      style={{ fontSize: '0.7rem', whiteSpace: 'nowrap' }}
                    >
                      {t8SubscriptionButtonLabel || 'T8'}
                    </button>
                  )}
                  {parseInt(permission) == 1 && (
                    <button
                      className="btn btn-sm btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center"
                      onClick={onAddLicense}
                      style={{
                        width: '32px',
                        height: '32px',
                        padding: 0,
                      }}
                    >
                      <i className="bi bi-plus-lg"></i>
                    </button>
                  )}
                </div>
              </div>
              <div>
                <table className="table table-sm table-bordered align-middle text-center bg-white mb-0 device-licenses-table">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: '40%' }}>Contenido</th>
                      <th style={{ width: '40%' }}>Hasta</th>
                      {parseInt(permission) == 1 && (
                        <th style={{ width: '20%' }}>Acciones</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {licenses && licenses.length > 0 ? (
                      licenses.map((license, index) => (
                        <tr key={index}>
                          <td className="text-start">
                            {license.content_name || license.content_id || 'N/A'}
                          </td>
                          <td>
                            <span className={license.end_date === 'VENCIDO' ? 'text-danger fw-bold' : ''}>
                              {formatDate ? formatDate(license.end_date) : license.end_date}
                            </span>
                          </td>
                          {parseInt(permission) == 1 && (
                            <td>
                              <div className="d-flex gap-1 justify-content-center">
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => onEditLicense && onEditLicense(license)}
                                  title="Editar fecha"
                                >
                                  <i className="bi bi-pencil"></i>
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => onDeleteLicense && onDeleteLicense(license)}
                                  title="Eliminar"
                                >
                                  <i className="bi bi-trash"></i>
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={parseInt(permission) == 1 ? 3 : 2} className="text-muted">No hay licencias registradas</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Panel 3: Soporte Remoto — solo administrador helpdesk */}
          {parseInt(permission) === 1 && (
            <div className="col-md-3">
              <div
                className="device-header-panel shadow-sm rounded"
                style={{
                  background: 'linear-gradient(90deg, #e0f2fe, #f0f9ff)',
                  border: '1px solid #dbeafe',
                }}
              >
                <h5 className="mb-1" style={{ fontSize: '0.85rem' }}>Soporte Remoto</h5>
                {showRemoteSupport ? (
                  <>
                    <p className="mb-2" style={{ fontSize: '0.85rem' }}>
                      <strong style={{ fontSize: '0.9rem' }}>PASO {currentStep}:</strong>
                      <br />
                      <span style={{ fontSize: '0.8rem' }}>{stepText}</span>
                    </p>
                    {(currentStep === 2 && isLoading) && (
                      <div className="alert alert-info d-flex align-items-center py-2" role="alert" style={{ fontSize: '0.75rem' }}>
                        <div className="custom-spinner text-primary me-2" role="status" style={{ width: '1rem', height: '1rem' }}>
                          <span className="visually-hidden">Cargando...</span>
                        </div>
                        <span dangerouslySetInnerHTML={{ __html: slotData }} style={{ fontSize: '0.75rem' }} />
                      </div>
                    )}
                    {currentStep === 2 && (
                      <div className="mt-2 text-center">
                        <img
                          src={remoteSupportButton}
                          alt="Botón Soporte remoto en TOMi8"
                          className="img-fluid rounded border"
                          style={{ maxHeight: '70px' }}
                        />
                      </div>
                    )}
                    {(currentStep === 3) && (
                      <>
                        <div className="alert alert-info d-flex align-items-center py-2" role="alert" style={{ fontSize: '0.75rem' }}>
                          <span style={{ fontSize: '0.75rem' }}>Conectate a:<br />team.tomi.la::{helpdesk_port}</span>
                          <button
                            className="btn btn-sm btn-outline-secondary ms-2"
                            onClick={handleCopy}
                            title="Copiar dirección"
                            style={{ fontSize: '0.7rem', padding: '0.2rem 0.4rem' }}
                          >
                            <i className="bi bi-clipboard"></i>
                          </button>
                        </div>
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={connectUser}
                          style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                        >
                          Descargar .vnc
                        </button>
                      </>
                    )}

                    <button
                      className="btn btn-primary btn-sm mt-2"
                      onClick={handleNextStep}
                      style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }}
                    >
                      {actionText}
                    </button>
                  </>
                ) : (
                  <div className="alert alert-secondary mb-0" role="alert" style={{ fontSize: '0.85rem' }}>
                    Esta funcionalidad esta disponible a partir de la version 200 en adelante del t8_touch_driver
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
    );
};

export default Device_header;